module.exports = "fragment SocProContactFragment on SocProContact {\n  __typename\n  id\n  contactId\n  metadataBlob\n  createdAt\n  updatedAt\n}\n"